export const APP_BASE_URL = "https://rifflexchain.com";
// export const APP_BASE_URL = "http://localhost:3001";

export const DEFAULT_QUERY_CONFIG_LONG_CACHE = 30 * 24 * 60 * 60 * 1000; //30 days
export const DEFAULT_QUERY_CONFIG_LONG_STALE_TIME = 24 * 60 * 60 * 1000; //1 day
